import React from "react";
import { Text, Image } from "@chakra-ui/react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
export const objtechstack = [
  {
    name: "Chakra UI",
    image: "https://img.icons8.com/color/350/chakra-ui.png",
  },
  {
    name: "HTML 5",
    image: "https://img.icons8.com/color/350/html-5--v1.png",
  },
  {
    name: "CSS3",
    image: "https://img.icons8.com/color/350/css3.png",
  },
  {
    name: "React Js",
    image: "https://img.icons8.com/color/240/react-native.png",
  },
  {
    name: "Node Js",
    image: "https://img.icons8.com/color/240/nodejs.png",
  },
  {
    name: "Vue Js",
    image: "https://img.icons8.com/color/240/vue-js.png",
  },

  {
    name: "Express Js",
    image: "https://img.icons8.com/nolan/240/express-js.png",
  },
  {
    name: "JavaScript",
    image: "https://img.icons8.com/color/240/javascript--v1.png",
  },
  {
    name: "Python",
    image: "https://img.icons8.com/color/240/python--v1.png",
  },
];

const objtoolstack = [
  {
    name: "Git",
    image: "https://img.icons8.com/color/240/git.png",
  },
  {
    name: "Mongo DB",
    image: "https://img.icons8.com/color/240/mongodb.png",
  },
  {
    name: "Netlify",
    image: "https://cdn.cdnlogo.com/logos/n/91/netlify.svg",
  },
  {
    name: "Vercel",
    image:
      "https://yt3.ggpht.com/a/AATXAJxYGxtZ8ZffTsTQSgxIS8MaYflyYvmve7IaGQ=s900-c-k-c0xffffffff-no-rj-mo",
  },
  {
    name: "Vs Code",
    image: "https://img.icons8.com/color/240/visual-studio-code-2019.png",
  },
  {
    name: "Flask",
    image: "https://img.icons8.com/nolan/240/flask.png",
  },
  {
    name: "Redux",
    image: "https://img.icons8.com/color/240/redux.png",
  },
];

const SkillsNew = () => {
  const items = objtechstack.map((el, i) => (
    <li style={{ margin: "0 8px", padding: "10px" }}>
      <button className="card tag-btn">
        <p className="btn-text" color="white">
          {el.name}
        </p>
        <div>
          <img className="skills-card-img" src={el.image} alt={el.name} />
        </div>
      </button>
    </li>
  ));
  const itemstool = objtoolstack.map((el, i) => (
    <li style={{ margin: "0 8px", padding: "10px", minHeight: "5cm" }}>
      <button className="card tag-btn">
        <p className="btn-text" color="white">
          {el.name}
        </p>
        <div>
          <img className="skills-card-img" src={el.image} alt={el.name} />
        </div>
      </button>
    </li>
  ));

  return (
    <section className="tags" id="skills">
      <div className="container">
        <h2 className="headline headline-2 section-title" id="tag-label">
          Professional <span className="span"> Skillset</span>
        </h2>

        <p className="section-text">Languages I know</p>

        <AliceCarousel
          items={items}
          responsive={{
            0: { items: 1 },
            768: { items: 3 },
            1024: { items: 5 },
          }}
          disableButtonsControls
          disableDotsControls
          autoPlayInterval={4000}
          autoPlay
          infinite
          mouseTracking
        />
        <br />
        <p className="section-text">Tools I use</p>
        <AliceCarousel
          items={itemstool}
          responsive={{
            0: { items: 1 },
            768: { items: 3 },
            1024: { items: 5 },
          }}
          disableButtonsControls
          disableDotsControls
          autoPlayInterval={3500}
          autoPlay
          infinite
          mouseTracking
        />
      </div>
    </section>
  );
};

export default SkillsNew;
